<template>
	<div class="main-container scoped-salary-rules">
		<div class="background-white box-shadow-small border-radius">
			<el-breadcrumb separator="/" class="mt-10 mb-25">
				<el-breadcrumb-item :to="{ name: 'paymentRules' }">定薪规则管理</el-breadcrumb-item>
				<el-breadcrumb-item>编辑规则</el-breadcrumb-item>
			</el-breadcrumb>
			<el-form label-width="90px" :model="ruleForm" :rules="rules" ref="form">
				<el-form-item label="规则名称:" prop="name">
					<el-input size="medium" v-model.trim="ruleForm.name" :maxlength="20"
							  placeholder="请输入规则名称" style="width: 300px;"></el-input>
				</el-form-item>
				<el-form-item label="是否启用:" class="is-required">
					<el-radio-group v-model="ruleForm.state">
						<el-radio :label="1">启用</el-radio>
						<el-radio :label="2">停用</el-radio>
					</el-radio-group>
					<span class="level-tip">（停用后将不能使用该定薪规则，但不影响历史数据）</span>
				</el-form-item>
				<el-form-item label="说明文档:">
					<el-upload
							class="upload-desc"
							:multiple="false"
							:action="action"
							:on-preview="handlePreview"
							accept="application/pdf"
							:on-success="handleFileSuccess"
							:on-remove="handleFileRemove"
							:file-list="fileList">
						<el-button size="small" type="primary">点击上传</el-button>
						<div slot="tip" class="file-upload-tip">（只限pdf格式）</div>
					</el-upload>
				</el-form-item>
				<el-form-item label="定级详情:" class="is-required">
					<div class="rule-row mb-15" v-for="(item, index) in paymentConfigs" :key="index">
						<div class="el-table el-table--fit el-table--border el-table--enable-row-transition" style="width: 602px;">
							<table class="el-table__body">
								<tr class="el-table__row">
									<td class="is-center" width="50"><div class="cell">定级</div></td>
									<td class="is-center" width="400"><div class="cell">
										<el-input size="medium" placeholder="请输入定级名称" v-model.trim="item.secLevel"></el-input></div></td>
									<td class="is-center" width="150">
										<div class="cell">
											<el-button type="text" @click="addInnerRow(item)">新增</el-button>
											<el-button type="text" style="color: #ff4949;" @click="paymentConfigs.splice(index, 1)" v-if="paymentConfigs.length>1">删除</el-button>
										</div>
									</td>
								</tr>
							</table>
						</div>
						<el-table :data="item.paymentList" style="width: 602px;" border align="center" class="rule-salary">
							<el-table-column header-align="center" align="center" width="50" type="index"></el-table-column>
							<el-table-column header-align="center" align="center" width="200" label="定薪" prop="paymentLevel">
								<template slot-scope="scope">
									<el-input size="medium" v-model.trim="scope.row.paymentLevel"></el-input>
								</template>
							</el-table-column>
							<el-table-column header-align="center" align="center" width="200" label="offer标准" prop="paymentMonth">
								<template slot-scope="scope">
									<el-input size="medium" v-model.trim="scope.row.paymentMonth" maxlength="10" />
								</template>
							</el-table-column>
							<el-table-column header-align="center" align="center" width="150" label="操作">
								<template slot-scope="scope">
									<el-button type="text" style="color: #ff4949;" @click="item.paymentList.splice(scope.$index, 1)" v-if="item.paymentList.length>1">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="mt-20">
						<el-button type="default" @click="addLevelBlock" icon="el-icon-plus">添加定级</el-button><span class="level-tip" v-if="paymentConfigs.length">（当前共{{paymentConfigs.length}}个定级）</span>
					</div>
				</el-form-item>
				<el-form-item class="handler-btns">
					<el-button type="primary" @click="onSubmit">保存</el-button>
					<el-button @click="$back({name: 'paymentRules'})">取消</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>
<script>
import FileUpload from 'components/fileUpload'
export default {
    components: {
        FileUpload
    },
    data () {
        return {
            action: `${this.$axios.defaults.baseURL}/payment/template/fileInsert.api`,
            fileList: [],
            ruleForm: {
                name: '',
                state: 1
            },
            rules: {
                name: {required: true, message: '请输入', trigger: 'blur'}
            },
            paymentConfigs: []
        }
    },
    created () {
        if (!this.isCreate) {
            this.$axios.post('/payment/template/getDetailById.api', {
                id: this.id
            }).then(res => {
                this.paymentConfigs = res.result.bean.configList
                this.ruleForm.name = res.result.bean.name
                this.ruleForm.state = res.result.bean.state
                this.fileList = res.result.bean.paymentAttachList
            })
        } else {
            this.addLevelBlock()
        }
    },
    computed: {
        id () {
            return this.$route.params.id
        },
        isCreate () {
            return this.id === 'create'
        }
    },
    methods: {
        handleFileSuccess (res, file) {
            if (res.status) {
                this.fileList = [res.result]
            } else {
                this.$message.error(res.desc || '上传失败')
            }
        },
        handleFileRemove (file, fileList) {
            this.fileList = fileList
        },
        handlePreview (file) {
            window.open(file.preUrl)
        },
        uploadRemove () {},
        defaultLevelData () {
            return {
                secLevel: '',
                paymentList: [{
                    paymentLevel: '',
                    paymentMonth: ''
                }]
            }
        },
        addLevelBlock () {
            this.paymentConfigs.push(this.defaultLevelData())
        },
        addInnerRow (data) {
            data.paymentList.push({
                paymentLevel: '',
                paymentMonth: ''
            })
        },
        checkLevelList () {
            let isSuccess = true
            let tip = ''
            this.paymentConfigs.forEach(item => {
                if (item.secLevel === '') {
                    isSuccess = false
                } else {
                    item.paymentList.forEach(one => {
                        if (one.paymentLevel === '' || one.paymentMonth === '') {
                            isSuccess = false
                        } else if (!/^\d+$/.test(one.paymentMonth)) {
                            isSuccess = false
                            tip = 'offer标准只能为数字'
                        }
                    })
                }
            })
            !isSuccess && this.$message.warning(tip || '定级详情表单不能为空')
            return isSuccess
        },
        onSubmit () {
            console.log(this.ruleForm, this.fileList)
            this.$refs.form.validate(valid => {
                if (valid && this.checkLevelList()) {
                    this.$axios.post('/payment/template/save.api', Object.assign({}, this.ruleForm, {
                        id: this.isCreate ? undefined : this.id,
                        md5: this.fileList.length ? this.fileList[0].md5 : '',
                        fileId: this.fileList.length ? this.fileList[0].fileId : '',
                        paymentConfigs: JSON.stringify(this.paymentConfigs)
                    })).then(res => {
                        this.$message.success('保存成功')
                        this.$router.push({name: 'paymentRules'})
                    })
                }
            })
        }
    }
}
</script>
<style type="text/css" lang="scss">
	.scoped-salary-rules{
		min-height: 500px;
		.file-upload-tip{
			padding-top: 5px;
			position: absolute;
			left: 240px;
			top: -7px;
			color: #aaa;
		}
		.level-tip{
			color: #aaa;
			margin-left: 30px;
		}
		.handler-btns{
			background: #fbfbfb;
			padding: 30px 80px;
			border: 1px solid #ddd;
			border-radius: 5px;
		}
		.rule-salary{
			th{
				height: 30px;
			}
			.is-leaf{
				font-weight: normal;
				.cell{
					color: #999;
				}
			}
		}
		.upload-desc{
			width: 300px;
		}
	}
</style>



// WEBPACK FOOTER //
// salayRuleDetail.vue?3975de5c